import { UserId } from "@sp-crm/core";

export const marketerGoalsPath = "/reports/show/marketer-goals";

export const manageGoalsPath = `${marketerGoalsPath}/manage`;

export const marketerGoalDetailPath = (marketerUserId: UserId): string =>
    `${marketerGoalsPath}/marketer/${marketerUserId}`;

export const editGoalsPath = (month: string): string => `${manageGoalsPath}/${month}`;

export const newGoalsPath = (firstMonth: string): string =>
    `${manageGoalsPath}/new/${firstMonth}`;

export const marketerGoalRoutes = {
    report: {
        exact: true,
        path: [`${marketerGoalsPath}/marketer/:marketerUserId`, marketerGoalsPath],
    },
    manage: { exact: true, path: manageGoalsPath },
    newGoals: { exact: true, path: `${manageGoalsPath}/new/:month` },
    editGoals: { exact: true, path: `${manageGoalsPath}/:month` },
};

export const isGoalMonth = (value: string): boolean => /^\d{4}-\d{2}$/.test(value);

export const legacyMarketerParam = (search: string): UserId | null =>
    (new URLSearchParams(search).get("marketer") as UserId | null) || null;
